import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { DateToLocal } from "components/dates";
import { ListingTable } from "components/listing";
import { Icon } from "@blueprintjs/core";
import { Tooltip } from "components/tooltip";
import { HelperFunctions } from "helpers";
import { ShowHide } from "components/layout";
import moment from "moment";

const defaultArray = [];

export function EmployeeLicenceCheckEndorsements({
    endorsements = defaultArray,
    checkDate,
    loading
}) {

    const tableHeaders = ["Status", "Code", "Offence Date", "Conviction Date", "Points", "Points Expiry Date", "Disqualified"];
    const [tableRows, setTableRows] = useState([]);

    const endorsementPointsStatus = (endorsement) => {
        if (!endorsement.points || !endorsement.penaltyPointsExpiryDate) {
            //This includes 0
            return <span>Undetermined</span>
        };

        const today = moment().startOf('day');
        const expiryDate = moment(endorsement.penaltyPointsExpiryDate);

        //if either of the valid dates are set and the current date is outside of the range, return false
        if (today.isAfter(expiryDate, 'day')) {
            return <span className="text-intent-success">Expired</span>
        } else {
            return <span className="text-intent-danger">Active</span>
        }
    }

    useEffect(() => {

        const sortedEndorsements = HelperFunctions.sortByDate(endorsements, "offenceDate", "desc");

        setTableRows(sortedEndorsements.map((endorsement) => {
            return [
                endorsementPointsStatus(endorsement),
                <div key={`${endorsement.code}-${endorsement.offenceDate}`} className="inline-items">
                    <div className="inline-items">
                        {endorsement.code}
                    </div>
                    <div className="inline-items">
                        <Tooltip content={endorsement.description}>
                            <Icon icon="info-sign" size={12} />
                        </Tooltip>
                    </div>
                </div>,
                <DateToLocal key={`${endorsement.code}-${endorsement.offenceDate}`} format="DD/MM/YYYY">{endorsement.offenceDate ?? '-'}</DateToLocal>,
                <DateToLocal key={`${endorsement.code}-${endorsement.offenceDate}`} format="DD/MM/YYYY">{endorsement.convictionDate ?? '-'}</DateToLocal>,
                endorsement.points,
                <DateToLocal key={`${endorsement.code}-${endorsement.offenceDate}`} format="DD/MM/YYYY">{endorsement.penaltyPointsExpiryDate ?? '-'}</DateToLocal>,
                endorsement.disqualified ? <span className="text-intent-danger">Yes</span> : "No"
            ];
        }));
    }, [endorsements]);

    return (
        <div>

            <ShowHide
                evaluator={checkDate != null}
                show={(
                    <div className="spacer-bottom">
                        <p>The information below was captured and was accurate as of the <DateToLocal format="DD/MM/YYYY">{checkDate ?? '-'}</DateToLocal></p>
                    </div>
                )}
            />
            <ListingTable
                id="listing-table-licence-endorsements"
                noDataMessage={"No endorsements on the employee's record"}
                sortable={false}
                headers={tableHeaders}
                data={tableRows}
                totalRecordCount={tableRows.length}
                loadingData={loading}
                pageable={false}
                showPerPage={false}
            />
        </div>
    );
}

EmployeeLicenceCheckEndorsements.propTypes = {
    endorsements: PropTypes.array.isRequired,
    checkDate: PropTypes.string,
    loading: PropTypes.bool
};